export enum ProfileTypes {
  BOOKING_FREE_OFFER_15_16 = 'booking',
  IDENTITY_CHECK = 'identityCheck',
}
